import { snack } from "components/Snack/Snack";
import CrudPage from "components/CrudPage/CrudPage";
import withRouter from "hoc/withRouter";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import { useLoadAll } from "hooks/useLoadAll";
import inputTypeEnum from "enums/inputTypes";
import integrationsSAService from "services/superadmin/integrationsSAService";
import AppSmartForm from "components/AppSmartForm/AppSmartForm";

const IntegrationForm = ({
  router: {
    navigate,
    params: { id },
  },
  data: { integration },
}) => {

  const fieldsWithData = [
    {
      key: "name",
      label: "Название",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "isActive",
      label: "Статус",
      inputType: inputTypeEnum.checkbox
    },
  ]

  const onSubmit = async (formValues) => {
    console.log("formValues: ", formValues);    
    try {
      if (integration) {
        await integrationsSAService.put(id, formValues)
        snack("Интеграция обновлен успешно!");
      } else {
        await integrationsSAService.post(formValues)
        snack("Интеграция создан успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex)
    }
  };

  return (
    <CrudPage title={integration ? 'Редактирование интеграции' : 'Создание интеграции'}>
      <AppSmartForm onSubmit={onSubmit} data={integration} fields={fieldsWithData}></AppSmartForm>
    </CrudPage>
  );
};

export default withRouter(
  withRemoteDataAndSpinner(IntegrationForm, (router) => {
    let requests = {}

    if (router.params.id) {
      requests['integration'] = () => integrationsSAService.get(router.params.id)
    }
    return useLoadAll(requests);
  })
);
